import React, { FC, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import { PostType } from 'api';
import { BlockListProvider, ContentProvider, SharePhotoProvider } from 'providers';

import { ComposeLayout } from 'features/compose';
import { initialPostUIState, postContextReducer, PostUIContext } from 'features/posting';

import { Form, FormButtons, PostFormBody, ShareForm, Tabs } from '../components/ExternalShare';
import { useProtectedClient } from 'hooks';
import { UploadCountProvider } from 'features/posting/components/ImageVideo/UploadCountProvider';

const ExternalShare: FC = () => {
  const { t } = useTranslation();
  const { id } = useProtectedClient();

  const [state, dispatch] = useReducer(postContextReducer, initialPostUIState);
  const [, forceUpdate] = useReducer((x: number) => x + 1, 0);
  const [initialPostValues] = useState({
    group_ids: ['0'],
    content_id: '',
    content_source_id: 'manual',
    content_object: {
      post_type: PostType.Quickshare,
      url: '',
      body: '',
      photos: [],
      media: null,
      url_metadata_override: {
        title: '',
        description: '',
      },
    },
  });

  return (
    <PostUIContext.Provider value={{ state, dispatch }}>
      <ContentProvider value={initialPostValues}>
        <SharePhotoProvider>
          <BlockListProvider client_id={id}>
            <UploadCountProvider>
              <Form initialPostValues={initialPostValues}>
                {({ isLoading, onSubmit, postFormikRef, shareFormikRef }) => (
                  <ComposeLayout
                    header={
                      <Grid item>
                        <Typography variant="h4">{t('sharing:shareToYourNetworks')}</Typography>
                      </Grid>
                    }
                    tabs={<Tabs />}
                    body={<PostFormBody onUpdate={forceUpdate} ref={postFormikRef} />}
                  >
                    <ShareForm onUpdate={forceUpdate} ref={shareFormikRef} />
                    <Grid item>
                      <FormButtons
                        loading={isLoading}
                        onSubmit={onSubmit}
                        postFormikProps={postFormikRef.current}
                        shareFormikProps={shareFormikRef.current}
                      />
                    </Grid>
                  </ComposeLayout>
                )}
              </Form>
            </UploadCountProvider>
          </BlockListProvider>
        </SharePhotoProvider>
      </ContentProvider>
    </PostUIContext.Provider>
  );
};

export default ExternalShare;
